import {
    IListaModeloRenegociacao,
    IListaModeloRenegociacaoGrupo,
} from "../../Interfaces/Cobranca/ModeloRenegociacaoGrupo/IModeloRenegociacaoGrupo";
import Axios from "../Config/API";
import Service from "../Service";

export async function ListarModeloRenegociacaoService() {
    return Service(
        Axios.get<Array<IListaModeloRenegociacao>>(
            `/cobranca/modelorenegociacao/listamodelorenegociacao`
        )
    );
}

export async function ListarModeloRenegociacaoGrupoService() {
    return Service(
        Axios.get<Array<IListaModeloRenegociacaoGrupo>>(
            `/cobranca/modelorenegociacao/listamodelorenegociacaogrupo`
        )
    );
}

export async function InserirModeloRenegociacaoGrupoService(
    resquestBody: IListaModeloRenegociacaoGrupo
) {
    return Service(
        Axios.post(
            `/cobranca/modelorenegociacao/vincularmodelorenegociacaogrupo`,
            resquestBody
        )
    );
}

export async function DeletarModeloRenegociacaoGrupoService(
    idModeloRenegociacaoGrupo: number
) {
    return Service(
        Axios.delete(
            `/cobranca/modelorenegociacao/removermodelorenegociacaogrupo?idModeloRenegociacaoGrupo=${idModeloRenegociacaoGrupo}`
        )
    );
}
